import { translate } from "app/filters/i18nFilter";
import RedirectButtonTracked from "app/pages/sales-intelligence/pages/home/containers/RedirectButton/RedirectButtonTracked";
import type { ListRow } from "app/pages/sales-intelligence/pages/home/types/table";
import { listsColumns } from "../../configuration/table-columns/lists/columns";
import ListsEmptyCardActionsContainer from "../../containers/ListsCardActionsContainer/ListsEmptyCardActionsContainer";
import type { ResultsViewModel } from "../../types/models";
import EmptyListsView from "../ListsCard/EmptyListsView";
import { StyledContentFooter, StyledResultsContainer, StyledResultsTable, StyledResultsTableWrapper } from "../styles";

type Props = Pick<ResultsViewModel<ListRow>, "results" | "areResultsOverLimit" | "metadata"> & {
    onRedirect(): void;
};

const ListsResultsView = ({ results, areResultsOverLimit, metadata, onRedirect }: Props) => {
    const myListResultTable = (
        <StyledResultsTable
            data={results as ListRow[]}
            columns={listsColumns}
            metadata={metadata}
            noDataComponent={<EmptyListsView actions={<ListsEmptyCardActionsContainer metadata={metadata} />} />}
        />
    );

    return (
        <StyledResultsContainer>
            {areResultsOverLimit ? (
                <>
                    {myListResultTable}
                    <StyledContentFooter>
                        <RedirectButtonTracked
                            metadata={metadata}
                            type="flat"
                            onClick={onRedirect}
                        >
                            {translate("si.pages.home.card.lists.action.view-lists")}
                        </RedirectButtonTracked>
                    </StyledContentFooter>
                </>
            ) : (
                <StyledResultsTableWrapper>{myListResultTable}</StyledResultsTableWrapper>
            )}
        </StyledResultsContainer>
    );
};

export default ListsResultsView;
